export default __webpack_public_path__ + "static/media/Poderes of the Ascension.fe2d4d7c.jpg";